import { useEffect, useState } from "react";
import commonAPI from "../api/admin/commonApi"; // apna path adjust karo

export const useStates = () => {
  const [stateList, setStateList] = useState([]);

  useEffect(() => {
    const fetchStatesData = async () => {
      const res = await commonAPI.stateList();
      if (res.code === 200) {
        setStateList(res.data);
      }
    };
    fetchStatesData();
  }, []);

  return stateList;
};

export const useConstituencies = (stateId) => {
  const [constituencyList, setConstituencyList] = useState([]);

  useEffect(() => {
    if (!stateId) return;

    const fetchConstituencyData = async () => {
      const res = await commonAPI.constituencyList({ stateId });
      if (res.code === 200) {
        setConstituencyList(res.data);
      }
    };
    fetchConstituencyData();
  }, [stateId]);

  return constituencyList;
};
